import { Model, fk, many, attr } from "redux-orm";
import { NaeSSchemaMap } from "../config/NaeSSchema";

class NoteModel extends Model {
  static reducer(action, NoteModel, session) {
    switch (action.type) {
      case "UPSERT_" + NaeSSchemaMap.Note.schema:
        action.payload.forEach((payload) => {
          const dbData = NoteModel.withId(payload.id);

          const upsertData = payload;
          if (dbData) {
            const keys = Object.keys(upsertData);
            let needChange = false;
            keys.map((key) => {
              if (
                JSON.stringify(upsertData[key]) !== JSON.stringify(dbData[key])
              ) {
                needChange = true;
              }
            });

            if (!needChange) {
              return;
            }
          }

          NoteModel.upsert(payload);
        });
        break;
    }
    // Return value is ignored.
    return session.state;
  }

  toString() {
    return this.id;
  }
  // Declare any static or instance methods you need.
}
NoteModel.modelName = "NoteModel";

NoteModel.fields = {
  id: attr(),
};

export default NoteModel;